module.exports = __webpack_public_path__ + "static/media/samlogo.74a86542.png";